import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Slider } from "@/components/ui/slider";
import { useApi, euro, errMsg } from "@/lib/api";
import { DeliveryPicker, deliveryValid } from "@/components/Delivery";

export const OfferDialog = ({ listing, open, onOpenChange, onDone }) => {
  const api = useApi();
  const floor = Math.round(listing.min_offer || listing.price * 0.6);
  const [amount, setAmount] = useState(Math.round(listing.price * 0.9));
  const [message, setMessage] = useState("");
  const [delivery, setDelivery] = useState({ delivery: "ritiro", address: "" });
  const [busy, setBusy] = useState(false);
  const discount = Math.round((1 - amount / listing.price) * 100);

  const submit = async () => {
    setBusy(true);
    try {
      await api("post", "/offers", { listing_id: listing.id, amount: Number(amount), message: message || null, ...delivery });
      toast.success("Offerta inviata al venditore");
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="offer-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Fai un'offerta al ribasso</DialogTitle>
          <DialogDescription>Prezzo richiesto {euro(listing.price)}. Il venditore può accettare o rifiutare.</DialogDescription>
        </DialogHeader>
        <div className="space-y-5 py-2">
          <div className="rounded-xl bg-amber-50 border border-amber-200 p-4">
            <p className="text-xs uppercase tracking-wider text-amber-700 font-medium">La tua offerta</p>
            <p className="font-mono text-3xl text-amber-900 mt-1" data-testid="offer-amount-display">{euro(amount)}</p>
            <p className="text-xs text-amber-700 mt-1">{discount > 0 ? `-${discount}% rispetto al prezzo` : "Deve essere inferiore al prezzo"}</p>
          </div>
          <Slider data-testid="offer-slider" min={floor} max={Math.round(listing.price) - 1} step={100} value={[Number(amount) || floor]} onValueChange={([v]) => setAmount(v)} />
          <Input data-testid="modal-fai-offerta-input" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
          <DeliveryPicker value={delivery} onChange={setDelivery} />
          <Textarea data-testid="offer-message-input" placeholder="Messaggio per il venditore (facoltativo)" value={message} onChange={(e) => setMessage(e.target.value)} />
        </div>
        <DialogFooter>
          <Button data-testid="modal-fai-offerta-submit" disabled={busy || !deliveryValid(delivery)} onClick={submit} className="w-full rounded-full bg-amber-600 hover:bg-amber-700">
            {busy ? "Invio..." : "Invia offerta"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
